import React, { Component } from 'react';
import { Navbar, Row } from 'react-bootstrap';
import { connect } from 'react-redux';

import HeaderLinks from './HeaderLinks.jsx';

import logo from '../../assets/img/MacizoLogo.png';

class Header extends Component {
	constructor(props) {
		super(props);
		this.mobileSidebarToggle = this.mobileSidebarToggle.bind(this);
		this.state = {
			sidebarExists: false,
			width: window.innerWidth
		};
	}

	updateDimensions = () => {
		this.setState({
			width: window.innerWidth
		});
	};

	logout = (event) => {
		if (event) {
			event.preventDefault();
		}

		localStorage.removeItem('token');
		this.props.history.push('');
	};

	mobileSidebarToggle(e) {
		if (this.state.sidebarExists === false) {
			this.setState({
				sidebarExists: true
			});
		}

		e.preventDefault();

		document.documentElement.classList.toggle('nav-open');

		var node = document.createElement('div');
		node.id = 'bodyClick';
		node.onclick = function() {
			this.parentElement.removeChild(this);
			document.documentElement.classList.toggle('nav-open');
		};

		document.body.appendChild(node);
	}

	componentDidMount() {
		window.addEventListener('resize', this.updateDimensions);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateDimensions);
	}

	render() {
		const isMobile = this.state.width <= 991;

		return (
			<Navbar fluid>
				<Navbar.Header>
					<Row
						style={{
							position: 'relative',
							display: 'flex',
							alignItems: 'center',
							width: '100%',
							margin: 0
						}}
					>
						<div className="no-visible">
							<i
								className={this.props.sidebarShow !== false ? 'pe-7s-menu' : 'pe-7s-keypad'}
								style={{
									fontSize: '35px',
									float: 'left',
									color: '#827E7E',
									borderRadius: '50%'
								}}
								onClick={() => this.props.clickHandler()}
							/>
						</div>

						<Navbar.Toggle
							onClick={this.mobileSidebarToggle}
							style={{
								float: 'left',
								marginLeft: '5px'
							}}
						/>

						{isMobile ? (
							<button
								type="button"
								onClick={this.logout}
								style={{
									position: 'absolute',
									right: '15px',
									top: '8px',
									zIndex: 999999,
									backgroundColor: '#2563eb',
									color: '#ffffff',
									border: 'none',
									borderRadius: '8px',
									padding: '8px 12px',
									fontSize: '12px',
									fontWeight: 'bold',
									cursor: 'pointer',
									display: 'flex',
									alignItems: 'center',
									gap: '6px',
									boxShadow: '0 4px 10px rgba(0,0,0,0.25)'
								}}
							>
								Salir
								<i
									className={'pe-7s-power'}
									style={{
										fontSize: '18px',
										color: '#ffffff'
									}}
								/>
							</button>
						) : null}
					</Row>
				</Navbar.Header>

				<Navbar.Collapse>
					<HeaderLinks {...this.props} />
				</Navbar.Collapse>

				<div
					style={{
						textAlign: 'center',
						marginTop: '-50px',
						position: 'relative',
						zIndex: 1,
						pointerEvents: 'none'
					}}
				>
					<img src={logo} alt="logo_image" width="15%" height="auto" />&nbsp;&nbsp;
				</div>
			</Navbar>
		);
	}
}

Header.propTypes = {};

Header.contextTypes = {};

function mapStateToProps(state) {
	return {};
}

export default connect(mapStateToProps)(Header);